import TemplateView from "../../../../TemplateView";

export default class Breadcrumb extends TemplateView {
    constructor({
        onClose = () => {}
    }) {
        super()

        this.onClose = onClose

        this.state = {
            caption: '',
            text: ''
        }

        this.onStatePropertyChanged('caption', caption => this.$caption.text(caption + ':'))
        this.onStatePropertyChanged('text', text => this.$text.text(text))
    }

    templateHtml() {
        return "<div class='breadcrumb'>" +
               "  <div class='caption'></div>" +
               "  <div class='text'></div>" +
               "  <div class='closeIcon'></div> " +
               "</div>"
    }

    afterRender() {
        this.$caption = this.find('.caption')
        this.$text = this.find('.text')
        this.find('.closeIcon').click(() => this.onClose())
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/components/hierarchyAssignmentsEditor/Breadcrumb.js